module.exports = __webpack_public_path__ + "static/media/sampleReport3.ef8a0c97.png";